module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "other-works-by-the-author"
    }
  }, [_c('h1', [_vm._v("Other Works by the Author")]), _vm._v(" "), _c('p', [_c('strong', [_c('em', [_c('span', {
    staticClass: "underline"
  }, [_vm._v("The Osgoode Trilogy")])])])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Conduct in Question")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Final Paradox")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("A Trial of One")])]), _vm._v(" "), _c('p', [_c('strong', [_c('em', [_c('span', {
    staticClass: "underline"
  }, [_vm._v("The Trilogy of Remembrance")])])])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("The Drawing Lesson")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("The Fate of Pryde")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Night Crossing.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72965ff6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch005.vue
// module id = 75
// module chunks = 0